// src/tutoriel/ancres.js — LES POINTS QUE LE TUTORIEL SAIT MONTRER.
//
// Le serveur déclare, pour chaque étape, l'ancre qu'elle vise ; le front pose
// l'attribut sur l'élément correspondant. C'est le seul contrat entre les
// deux, et il est vérifié des DEUX CÔTÉS (scripts/check-tuto-ancres.js ici,
// test/tutoriels.test.js là-bas) : une bulle qui pointe dans le vide ne se
// voit pas en relecture, elle se voit en production.
//
// Règle de pose : une ancre sur une LISTE vise le premier élément
// (`index === 0`), jamais tous — sinon la recherche en prend un au hasard.
export const ANCRES = [
  'nav', 'notifs', 'copilote',
  'besoins-liste', 'besoin-creer', 'besoin-entete', 'besoin-candidats', 'besoin-annonce',
  'matching-lancer', 'matching-exigences', 'score-chip', 'score-detail',
  'bon-a-envoyer', 'pret-a-envoyer', 'faire-qualifier', 'qualifications-liste',
  'pipeline', 'candidats-liste', 'candidat-ajouter', 'fiche-entete', 'npc',
  'vivier-liste', 'positionner', 'entretien',
  'qualification-process', 'qualification-verdict', 'actions',
  'documents-suivi',
  'liste-noire', 'propositions-paquet', 'crm-onglets', 'crm-centre',
  'assistant-site', 'ao-controle-qualite',
];

/** À étaler sur l'élément : <button {...ancre('besoin-creer')}> */
export const ancre = (cle) => ({ 'data-tuto': cle });

/**
 * L'élément VISIBLE d'une ancre.
 *
 * `querySelector` ne suffit pas : certains éléments existent en double —
 * la cloche des notifications, par exemple, vit dans la barre supérieure
 * mobile ET dans la barre latérale, l'une des deux étant masquée par le CSS
 * selon la largeur. Prendre le premier du DOM ferait pointer la bulle sur un
 * élément invisible, et donc sur rien.
 */
export const elementAncre = (cle) => {
  if (!cle || typeof document === 'undefined') return null;
  const tous = document.querySelectorAll(`[data-tuto="${cle}"]`);
  for (const el of tous) {
    const r = el.getBoundingClientRect();
    if (r.width > 0 && r.height > 0) return el;
  }
  return null;
};
